import { Injectable } from '@angular/core';
import { Client } from 'src/app/domain/client';
import { Contact } from 'src/app/domain/contact';
import { Partner } from 'src/app/domain/partner';
import { User } from 'src/app/domain/user';
import { environment } from 'src/environments/environment';
import { CoreDataService } from './core-data.service';
import jwtDecode from 'jwt-decode';

@Injectable()
export class CoreData {

    private TOKEN = `${environment.appName}_TOKEN_` + environment.name;
    private WITH_OAUTH = `${environment.appName}_WITH_OAUTH_` + environment.name;
    private SCOPE = `${environment.appCode}_SCOPE`;
    private selectedPartner: Partner | undefined;
    private selectedClient!: Client | undefined;
    private selectedContact!: Contact | undefined;

    constructor(private coreDataService: CoreDataService) { }

    set Token(token: string) {
        localStorage.setItem(this.TOKEN, token);
    }

    get Token() {
        return localStorage.getItem(this.TOKEN) as string;
    }

    clearToken(): void {
        localStorage.removeItem(this.TOKEN);
    }

    get IsMobile() {
        return window.navigator.userAgent.includes('Mobi');
    }

    get isMEL() {
        return environment.isMel;
    }

    set User(u: User | undefined) {

        if (u) {
            localStorage.setItem(this.TOKEN, btoa(JSON.stringify(u)));
        } else {
            localStorage.removeItem(this.TOKEN);
        }
    }

    getUserFromJWTToken() {
        const u = new User();
        const decodedToken = jwtDecode(this.Token) as any
        if (decodedToken) {
            u.Email = decodedToken.email;
            u.FirstName = decodedToken.given_name;
            u.LastName = decodedToken.display_name.split(' ')[1];
        }
        return u;
    }

    get User(): User | undefined {
        return this.WithOauth2 ? this.getUserFromJWTToken() : JSON.parse(atob(this.Token))
    }

    get WithOauth2() {
        return Boolean(JSON.parse(localStorage.getItem(this.WITH_OAUTH) as string));
    }

    set WithOauth2(withOauth2: boolean) {
        localStorage.setItem(this.WITH_OAUTH, `${withOauth2}`);
    }

    get SelectedScopeCode() {
        return localStorage.getItem(this.SCOPE)!;
    }

    set SelectedScopeCode(scope: string) {
        localStorage.setItem(this.SCOPE, scope);
    }

    public get IsLoggedIn() {
        return this.Token && this.Token !== '' || false;
    }

    public set SelectedPartner(u: Partner | undefined) {
        if (u==undefined ||  this.selectedPartner?.Code != u.Code)
        {
        this.selectedPartner = u;
        this.coreDataService.sendUpdate();
        }
    }

    public get SelectedPartner(): Partner | undefined {

        return this.selectedPartner;
    }

    public set SelectedClient(u: Client | undefined) {
      if (u == undefined ||this.selectedClient != u)
        {
     
        this.selectedClient = u;
        this.coreDataService.sendUpdate();
        }
    }

    public get SelectedClient(): Client | undefined {
        return this.selectedClient;
    }
    public set SelectedContact(u: Contact | undefined) {
        if (u==undefined || this.selectedContact != u)
        {
        this.selectedContact = u;
        this.coreDataService.sendUpdate();
        }
    }

    public get SelectedContact(): Contact | undefined {
        return this.selectedContact;
    }
}
